import React from 'react';
import {fetchUtils, Button, SimpleForm, Filter, BooleanInput, required, Toolbar, SaveButton,
  DateField, Edit, Create, List, Datagrid, TextField, TextInput, SelectArrayInput, FormDataConsumer,
  ReferenceArrayInput, AutocompleteArrayInput, SelectInput, DateInput} from 'react-admin';
import DataTable from 'react-data-table-component';
import CloudDownload from '@material-ui/icons/CloudDownload';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';

const utils = require('./components/utils');
const dataSupport = require('./components/data_support.js');

const fetch = fetchUtils.fetchJson;
const BASE_URL = window.nobid_endpoint + '/ad_domains_report';

const choicesInterval = [
  { id: 'day', name: 'Daily' },
  { id: 'week', name: 'Weekly' },
  { id: 'month', name: 'Monthly' },
  { id: 'year', name: 'Yearly' }
];

const showChoices = [
  { id: 'date', name: 'Date' },
  { id: 'publisher', name: 'Publisher' },
  { id: 'bidder', name: 'Bidder' },
  { id: 'tldomain', name: 'Site Domain' },
  { id: 'adomain', name: 'Advertiser Domain' }
];

const dateRangeChoices = [
  { id: '0', name: 'Today' },
	{ id: 1, name: 'Yesterday' },
	{ id: 2, name: 'Last 2 Days' },
	{ id: 3, name: 'Last 3 Days' },
	{ id: 7, name: 'Last 7 Days' },
	{ id: 8, name: 'Last 8 Days' },
	{ id: 10, name: 'Last 10 Days' },
	{ id: 30, name: 'Last 30 Days' },
  { id: 'lm', name: 'Last Month' },
  { id: 'mtd', name: 'Month to Date' },
  { id: 'mty', name: 'Month to Yesterday' },
	{ id: 'custom', name: 'Custom' }
];

let BASE_COLUMNS = [
  { name: 'Date', selector: 'date', sortable: true },
  { name: 'Publisher', selector: 'publisher_name', sortable: true, cell: row => <span>{ `${row.publisher_name} (${row.publisher_id})` }</span> },
  { name: 'Bidder', selector: 'bidder_name', sortable: true, cell: row => <span>{ row.bidder_name ? `${row.bidder_name} (${row.bidder_id})` : '-' }</span> },
  { name: 'Site Domain', selector: 'tldomain', sortable: true },
  { name: 'Advertiser Domain', selector: 'adomain', sortable: true },
  { name: 'Impressions', selector: 'impressions', alwaysOn: true, sortable: true, cell: row => utils.formatLong(row.impressions, ' ') }
];

let columns = BASE_COLUMNS;

const AdDomainsTitle = ({ record }) => {
  return <span>Advertiser Domains Report {record ? `"${record.name}"` : ''}</span>;
};
const AdDomainsFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
    </Filter>
);
export const AdDomainsReportList = (props) => (
  <List {...props} title="Advertiser Domains Reports" perPage={25} bulkActionButtons={false} filters={<AdDomainsFilter />} 
  exporter={false} >
    <Datagrid rowClick="edit">
      <TextField source="name" label="Name" />
      <DateField source="updated_at" label="Update Date" />
      <DateField source="created_at" label="Creation Date" />
      <DeleteWithConfirmation {...props}/>
    </Datagrid>
  </List>
);
class CustomToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.parent = props.parent;
  }
  fetchData() {
    function updateState(that, headers, json) {
      // The Show ids are bare dimension names ('publisher', 'bidder'), but the
      // columns they control are the derived fields the reporter actually
      // returns ('publisher_id'/'publisher_name'), so each id must be expanded
      // before it can be matched against a column selector. Comparing the raw
      // id silently dropped the Publisher and Bidder columns (NBU-8). Same
      // expansion as adstxtreports.js and adquality_reports.js.
      const showList = formData.show || [];
      const columnSelectors = showList.flatMap(x => [x, `${x}_id`, `${x}_name`, `${x}_group`]);
      that.parent.setState({
        data: json.data,
        columns: BASE_COLUMNS.filter(c => c.alwaysOn || columnSelectors.includes(c.selector)),
        loading: false,
        total: json.total
      });
    }
    let show='';
    if (formData.show) formData.show.forEach(item => { show+='&show='+item; });

    this.parent.setState({loading: true, total: '---'});
    let url = `${BASE_URL}?${show}`+
    `${utils.formDataFieldsQueryStringFormat(formData, ['interval', 'date_range', 'start_date', 'end_date',
      'publisher_id', 'bidder_id', 'tldomain', 'adomain'])}`;
    let options = { headers: new Headers() };
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    console.log('url => ', url);
    fetch(url, options).then(({ headers, json }) => (
      updateState(this, headers, json)
    )).catch(error => {
      // Without this the spinner runs forever on any backend failure, which is
      // how the NBI-34 org-clause breakage presented for four months. insights
      // hangs rather than 500ing on a report error, so surface it and release
      // the form instead of leaving the page stuck in loading.
      console.error('Ad Domains report failed', error);
      this.parent.setState({ loading: false, total: '---' });
    });
  }
  handleSearch = () => {
    this.fetchData();
  }

  render() {
    return <Toolbar>
      <SaveButton style={{marginRight: '25px'}} variant='contained' 
        color='primary' disabled={this.parent.state.loading} {...this.props} />
      <br />
      <Button label='Run Report' onClick={this.handleSearch} props={this} variant='contained' color='primary' 
        startIcon={<RunReportIcon />} style={{marginRight: '5px', padding: '7px', width: '160px'}} 
        disabled={this.parent.state.loading} />
      <br />
      {this.parent.props.formType==='edit' &&
        <span>
        <DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
        <TextField source="updated_name" label="" style={{ padding: '10px' }} />
        </span>
      }
    </Toolbar>
  }
};
let formData = {};
function setFormData(formdata) {
  formData = formdata;
}
class AdDomainsComponent extends React.Component {
  state = {
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params : ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL,
    dateRange: this.props.record.date_range
  };
  render() {
    const { loading, data, total, dateRange } = this.state;
    const { permissions } = this.props;
    return (
      <div>
        <SimpleForm toolbar={<CustomToolbar parent={this} />} redirect='edit' {...this.props}>
          <TextInput source="name" label="Report Name" style={{ width: '400px' }} validate={required()} />
          <FormDataConsumer>
            {({ formData }) => setFormData(formData) }
          </FormDataConsumer>
          <div style={{ display: 'flex', columnGap: '5px' }} id="wrapper3">
            <SelectInput label="Interval" source="interval" choices={choicesInterval} defaultValue='day' disabled={loading}/>
            <div>
              <SelectInput label="Date Range" source="date_range"
                onChange={value => this.setState({ dateRange: value.target.value })}
                choices={dateRangeChoices}
                defaultValue="8"
                disabled={loading} />
              <div style={{ float: 'right', paddingLeft: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                <div style={{ float: 'left', paddingRight: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                  <DateInput label="Start Date" source="start_date" allowEmpty disabled={loading}
                    style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} />
                </div>
                <div style={{ float: 'left', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                  <DateInput label="End Date" source="end_date" allowEmpty disabled={loading}
                    style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} />
                </div>
              </div>
            </div>

            <div>
              <SelectArrayInput label="Show"
              source="show"
              choices={showChoices}
              style={{ width: '400px' }}
              disabled={loading} />
            </div>
          </div>
          <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '5px' }}>     
            <div>
              <ReferenceArrayInput
                source="publisher_id" 
                label="Publishers" 
                reference="publishers"
                basePath="publishers"
                perPage={15} 
                sort={{ field: 'name', order: 'ASC' }}
                filterToQuery={searchText => ({ search_name: searchText })}
                disabled={loading}>
                <AutocompleteArrayInput disabled={loading} 
                  optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''}
                  optionValue="code"
                  fullWidth
                />
              </ReferenceArrayInput>
            </div>

            <div>
              <ReferenceArrayInput
                source="bidder_id"
                label="Bidders"
                reference="bidders"
                basePath="bidders"
                perPage={15} 
                sort={{ field: 'name', order: 'ASC' }}
                filterToQuery={searchText => ({ search_name: searchText })}
                disabled={loading}>
                <AutocompleteArrayInput disabled={loading} 
                  optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''}
                  optionValue="code"
                  fullWidth
                />
              </ReferenceArrayInput>
            </div>

            <div>
            <TextInput source="tldomain" label="Site Domain (Comma separated)" 
                style={{ width: '400px' }} 
                disabled={loading}/>
            </div>

            <div style={{flex: 1}}>
            <TextInput source="adomain" label="Advertiser Domain (Comma separated)" 
                style={{ width: '400px' }} 
                disabled={loading}/>
            </div>

          </div>
        </SimpleForm>
        <div style={{ height: '5px' }} />
        <DataTable
          title={`${total} Matching Results`}
          theme={window.nobid_table_theme()}
          columns={this.state.columns}
          data={data}
          progressPending={loading}
          pagination
          fixedHeader
          dense
          paginationPerPage={30}
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          subHeader={!loading}
          subHeaderComponent={
            (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input type="text" id='search_box' label="Search"
              variant="outlined"
              style={{ margin: '5px' }}
              onChange={(target) => dataSupport.filterData(this)} />
              <CloudDownload
              label="Export"
              style={{ margin: '5px' }}
              color="action"
              onClick={() => dataSupport.exportData(this.state.data)}
              />
            </div>
            )
          }
        />
      </div>
    )
  }
}
export const AdDomainsReportEdit = ({permissions, ...props}) => (
  <Edit title={<AdDomainsTitle />} {...props}>
    <AdDomainsComponent formType="edit" permissions={props.permissions} {...props} />
  </Edit>
);

export const AdDomainsReportCreate = ({permissions, ...props}) => (
  <Create title="Create Advertiser Domain Report" {...props}>
    <AdDomainsComponent formType="create" permissions={props.permissions} {...props} />
  </Create>
);